/** @jsxImportSource theme-ui */
import WidgetConfigurations from '@/containers/widget/WidgetConfigurations';

const WidgetConfigurationsPage = () => <WidgetConfigurations />;

export default WidgetConfigurationsPage;
